import { Component, computed, effect, inject, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ColorService } from '../../services/color.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormatDurationPipe, IconType } from '@kinomap-dev/ng-ui-lib/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { MediaBlockService } from '../../services/media-block-service';
import { UploadService } from '../../services/upload-service';
import { FileSizePipe } from '../../pipes/file-size.pipe';
import { WheelLoader } from '@kinomap-dev/ng-ui-lib/loaders';

@Component({
  selector: 'app-upload-file-progress-block',
  imports: [IconComponent, TranslateModule, UpperFirstLetterPipe, FormatDurationPipe, FileSizePipe, WheelLoader],
  templateUrl: './upload-file-progress-block.html',
  styleUrl: './upload-file-progress-block.scss',
  host: {
    class: 'field'
  }
})
export class UploadFileProgressBlock {
  colorService: ColorService = inject(ColorService);

  uploadService: UploadService = inject(UploadService);
  mediaBlockService: MediaBlockService = inject(MediaBlockService);

  uploadStatus: Signal<'complete' | 'pending' | 'in_progress'> = computed(() => {
    if (!this.progress()) return 'pending';
    if (this.progress()! >= 100) return 'complete';
    return 'in_progress';
  });

  icon: InputSignal<IconType> = input.required();
  title: InputSignal<string> = input.required();

  uploadUrl: InputSignal<string | undefined> = input<string | undefined>();
  file: InputSignal<File | undefined> = input<File | undefined>();
  /** Progression fournie par l'appelant quand il n'y a pas de fichier a envoyer sur S3 (workout). */
  progressSource: InputSignal<Observable<number> | undefined> = input<Observable<number> | undefined>();

  fileWeight: InputSignal<number | undefined> = input.required();
  fileDuration: InputSignal<number | undefined> = input.required();
  fileName: InputSignal<string | undefined> = input.required();

  complete: OutputEmitterRef<void> = output()

  private readonly uploadSource: Signal<{ file?: File; url?: string; source?: Observable<number> }> = computed(() => ({
    file: this.file(),
    url: this.uploadUrl(),
    source: this.progressSource(),
  }));

  progress = toSignal(
    toObservable(this.uploadSource).pipe(
      switchMap(({ file, url, source }): Observable<number> => {
        if (source) return source;
        return file && url ? this.uploadService.uploadToS3(url, file) : EMPTY;
      }),
    ),
    { initialValue: 0 },
  );

  constructor() {
    effect(() => {
      if (this.progress() === 100) this.complete.emit();
    })
  }
}
